import { MemberInfoResDto } from "../../dto/vending/MemberInfoResDto";
import { PromotionDto } from "../../dto/vending/PromotionDto";
import { VMProductInfoDto } from "../../dto/vending/VMProductInfoDto";
import productType, { IProductAction, ProductState } from "./product.type";

const initialState: ProductState = {
    isLoading: false,
    error: null,
    productSearchResult: undefined,
    isSearching: false,
    layout: undefined,
    productList: undefined,
    productGroupList: undefined,
    productCafeGroupList: undefined,
    promotionList: undefined,
};


// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: IProductAction) => {
    switch (action.type) {
        case productType.SEARCH.RESULT:
            return {
                ...state,
                productSearchResult: action.payload as VMProductInfoDto[],
                isSearching: true,
            };
        case productType.SEARCH.RESET:
            return {
                ...state,
                productSearchResult: new Array<VMProductInfoDto>(),
                isSearching: false,
            };
        case productType.PRODUCT.START_LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case productType.PRODUCT.STOP_LOADING:
            return {
                ...state,
                isLoading: false,
            };
        case productType.PRODUCT.MEMBER_INFO_SUCCESS:
            return {
                ...state,
                memberInfo: action.payload as MemberInfoResDto,
            };
        case productType.PRODUCT.MEMBER_INFO_FAIL:
            return {
                ...state,
            };
        // Layout
        case productType.LAYOUT_TRG.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case productType.LAYOUT_TRG.SUCCESS:
            return {
                ...state,
                layout: action.payload,
                isLoading: false,
            };
        case productType.LAYOUT_TRG.ERROR:
            return {
                ...state,
                isLoading: false,
            };
        case productType.LAYOUT_TRG.CLEAN:
            return {
                ...state,
                layout: undefined,
            };
        // Product
        case productType.PRODUCT_TRG.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case productType.PRODUCT_TRG.SUCCESS:
            return {
                ...state,
                productList: action.payload as VMProductInfoDto[],
                isLoading: false,
            };
        case productType.PRODUCT_TRG.ERROR:
            return {
                ...state,
                isLoading: false,
            };
        case productType.PRODUCT_TRG.CLEAN:
            return {
                ...state,
                productList: undefined,
            };
        // Product group
        case productType.PRODUCT_GROUP_TRG.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case productType.PRODUCT_GROUP_TRG.SUCCESS:
            return {
                ...state,
                productGroupList: action.payload as VMProductInfoDto[],
                isLoading: false,
            };
        case productType.PRODUCT_GROUP_TRG.ERROR:
            return {
                ...state,
                isLoading: false,
            };
        // Product cafe
        case productType.PRODUCT_CAFE_GROUP_TRG.SUCCESS:
            return {
                ...state,
                productCafeGroupList: action.payload as VMProductInfoDto[],
            };
        case productType.PRODUCT_CAFE_GROUP_TRG.CLEAN:
            return {
                ...state,
                productCafeGroupList: undefined,
            };
        // Promotion
        case productType.PROMOTION_TRG.LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case productType.PROMOTION_TRG.SUCCESS:
            return {
                ...state,
                promotionList: (Array.isArray(action.payload) ? action.payload : []) as PromotionDto[],
                isLoading: false,
            };
        case productType.PROMOTION_TRG.ERROR:
            return {
                ...state,
                isLoading: false,
            };
        case productType.PROMOTION_TRG.CLEAN:
            return {
                ...state,
                promotionList: undefined,
            };
        default:
            return state;
    }
};
